var map = {
	"./Danielle-Walker": 620,
	"./Danielle-Walker-p-500x501": 621,
	"./Danielle-Walker-p-500x501.jpeg": 621,
	"./Danielle-Walker.jpg": 620,
	"./Sarah-Hood": 622,
	"./Sarah-Hood-p-500x501": 623,
	"./Sarah-Hood-p-500x501.jpeg": 623,
	"./Sarah-Hood.jpg": 622,
	"./amazon": 624,
	"./amazon.png": 624,
	"./default-avatar": 165,
	"./default-avatar.svg": 165,
	"./etsy": 625,
	"./etsy.png": 625,
	"./favicon-16x16": 626,
	"./favicon-16x16.png": 626,
	"./favicon-32x32": 627,
	"./favicon-32x32.png": 627,
	"./global-stats-chart-default": 395,
	"./global-stats-chart-default.png": 395,
	"./global-stats-numbers-default": 396,
	"./global-stats-numbers-default.png": 396,
	"./icon-down-arrow": 628,
	"./icon-down-arrow.svg": 628,
	"./lady-in-cafe": 629,
	"./lady-in-cafe-p-1080x607": 630,
	"./lady-in-cafe-p-1080x607.jpeg": 630,
	"./lady-in-cafe-p-500x281": 631,
	"./lady-in-cafe-p-500x281.jpeg": 631,
	"./lady-in-cafe-p-800x450": 632,
	"./lady-in-cafe-p-800x450.jpeg": 632,
	"./lady-in-cafe.jpg": 629,
	"./logo": 394,
	"./logo-without-text": 633,
	"./logo-without-text.svg": 633,
	"./logo.svg": 394,
	"./phone": 634,
	"./phone-p-500x1019": 635,
	"./phone-p-500x1019.png": 635,
	"./phone.png": 634,
	"./shopify": 636,
	"./shopify.png": 636,
	"./squarespace": 637,
	"./squarespace.png": 637,
	"./wordpress": 638,
	"./wordpress.png": 638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1002;